// Oil pool fragment shader
// Amber/golden color with iridescent depths, elliptical alpha mask

uniform float uTime;
varying vec2  vUv;
varying float vElevation;

void main() {
    // Elliptical alpha mask — oval pool in a candle
    vec2  c      = vUv - vec2(0.5);
    float ellipse = length(c * vec2(1.0, 1.35));
    float alpha   = 1.0 - smoothstep(0.36, 0.50, ellipse);

    // Deep amber base
    vec3 baseColor   = vec3(0.70, 0.44, 0.08);
    // Golden peak highlights
    vec3 goldColor   = vec3(0.97, 0.82, 0.35);
    // Cool iridescent tint in troughs
    vec3 iridColor   = vec3(0.42, 0.52, 0.62);

    float elevNorm  = (vElevation + 0.15) / 0.30;            // 0–1
    float highlight = smoothstep(0.60, 1.0, elevNorm);
    float depth     = smoothstep(0.0, 0.30, elevNorm);

    vec3 col = mix(iridColor * 0.55, baseColor, depth);
    col      = mix(col, goldColor, highlight * 0.72);

    // Subtle animated specular ring
    float spec  = sin(ellipse * 6.28 + uTime * 1.1) * 0.04 + 0.04;
    col        += vec3(spec * 0.9, spec * 0.7, spec * 0.1) * alpha;

    gl_FragColor = vec4(col, alpha * 0.90);

    #include <colorspace_fragment>
}
